import '../../assets/styles/family-chart.css';

import React, {
  useEffect,
  useRef,
  useState,
} from 'react';

import { useParams } from 'react-router-dom';

import f3 from '../../FamilyTree/index.js';
import { get } from '../../service/apiService';
import Nav from '../SecureNav/Nav';
import InviteAction from '../Tree/InviteAction';
import TestDialog from './TestDialog.js';
import StarterDialog from './StarterDialog.js'
import axiosInstance from '../../axios.js';
import { API_BASE_URL } from '../../constants.js';
import { EditText } from 'react-edit-text';

const DEFAULT_USER_ID = "09203910-0dd0-426d-8e80-1d30c9b54ab4";

function customAddBtn(card_dim) {
  return `
    <g class="customAddBtn" style="cursor: pointer">
      <g transform="translate(${card_dim.w - 12},${card_dim.h - 12})scale(.08)">
        <circle r="100" fill="#fff" />
        <g transform="translate(-50,-45)">
          <line
            x1="10" x2="90" y1="50" y2="50"
            stroke="currentColor" stroke-width="20" stroke-linecap="round"
          />
          <line
            x1="50" x2="50" y1="10" y2="90"
            stroke="currentColor" stroke-width="20" stroke-linecap="round"
          />
        </g>
      </g>
    </g>
  `;
}

function customAddBtnListener(store, props) { }

function cardDisplay() {
  const d1 = (d) => `${d.data["first_name"] || ""} ${d.data["last_name"] || ""}`;
  const d2 = (d) => `${d.data["dob"] || ""}`;
  const d3 = (d) => {
    if (d.data["last_login"] === null && d.data["mobile"] && d.data["authenticated"] === "N") {
      return "invite";
    } else {
      return "";
    }
  };
  d1.create_form = "{first_name} {last_name}";
  d2.create_form = "{dob}";
  d3.create_form = "invite";
  return [d1, d2, d3];
}

function FamilyTree() {
  const { userId } = useParams();

  const familyChartRef = useRef(null);
  const [setData] = useState(null);
  console.log(userId)
  const defaultUserId = userId || DEFAULT_USER_ID;
  const router_url = `responsive-tree/${defaultUserId}`;
  const [isModalOpen, setModalOpen] = useState(false);
  const [mobile, setmobile] = useState("");
  const [memberId, setMemberId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [memberFamilyName,setMemberFamilyName]=useState("")

  const [memberDetails,setMemberFamilyDetails]=useState({})
  const [memberName, setMemberName] = useState("");
  const [clickedMemberRelativeDetails,setClickedMemberRelativeDetails]=useState({})
  const [open, setOpen] = useState(false);
  const [openStarter, setOpenStarter] = useState(false);
  const color_obj={"#CCFFCC":false,"#FFFFCC":false,"#E6CCFF":false,"#CC6677":false,"#FFCCDD":false}
  const existingMember={}
  const [isLocked, setIsLocked] = useState(false);
  const [lockedBy, setLockedBy] = useState(null);
  const lockRef = useRef({ isLocked, lockedBy });
  const closeModal = () => {
    setModalOpen(false);
  };

  const handleInviteAction = () => {
    closeModal();
  };

  const handleCancel = () => {
    closeModal();
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    setmobile(value);
  };
  const handleFamilyNameChange= (event) => {
    const { value } = event.target;
    setMemberFamilyName(value);
  };

  const handleFinalFamilyNameChange= (event) => {
     if(! event.value)
      {
        setMemberFamilyName("Enter family name!");
      }
     const response =  axiosInstance.put(`${API_BASE_URL}member-family/`+memberDetails.id+"/", {member_family_name:event.value,member:defaultUserId,family:memberDetails.family}
    );
  };
useEffect(() => {
  lockRef.current = { isLocked, lockedBy };
}, [isLocked, lockedBy]);

  useEffect(() => {
    const fetchDataAndUpdate = async () => {
      let familyId=""
      let font_family="";
      let male_color='#dde8fe';
      let female_color='#fae6ff';
      const card_dim = {
        w: 220,
        h: 70,
        text_x: 75,
        text_y: 15,
        img_w: 60,
        img_h: 60,
        img_x: 5,
        img_y: 5,
      };
      const card_display = cardDisplay();

      try {
            await axiosInstance.get(API_BASE_URL+"member-family/?search="+defaultUserId).then((response)=>{
                  if(response && response.data && response.data.data && response.data.data[0]){
                    familyId=response.data.data[0].family
                    if(!response.data.data[0].member_family_name)
                      setMemberFamilyName("Enter family name!")
                    else{
                      setMemberFamilyName(response.data.data[0].member_family_name);
                    }
                  setMemberFamilyDetails(response.data.data[0])
                }
            });
             await axiosInstance.get(API_BASE_URL+"user-settings/"+defaultUserId).then((response)=>{
                    console.log(response);
                    if(response && response.data){
                      font_family=response.data.font_family
                      male_color=response.data.male_color
                      female_color=response.data.female_color
                  }
                  });
            await axiosInstance.get(router_url).then((response)=>{
                  if(response.data.relogin_required){
                    const baseUrl = window.location.origin;
                    const url = `${baseUrl}/logout`;
                    alert("Something has changed. Hence, you need to login again to see the updated changes.")
                      window.location.href=url
                  }
                  const responseData=response.data.data
                  if(responseData && responseData.length!=0){
                    const store = f3.createStore({
                      data: responseData,
                      backupStash:[],
                      node_separation: 250,
                      level_separation: 150,
                    });

                    const view = f3.d3AnimationView({
                      store,
                      cont: familyChartRef.current,
                    });

                    const Card = f3.elements.Card({
                      store,
                      svg: view.svg,
                      card_dim,
                      card_display,
                      mini_tree: true,
                      link_break: false,
                      hide_rels: true,
                      node_separation: 250,
                      level_separation: 150,
                      cardEditForm,
                      custom_elements: [
                        {
                          el: customAddBtn(card_dim),
                          lis: customAddBtnListener,
                          query: ".customAddBtn",
                        },
                      ],
                      addRelative: AddRelative,
                      colors:color_obj,
                      existingMember:existingMember,
                      family_id:familyId,
                      member_count:responseData.length,
                      font_family:font_family,
                      male_color:male_color,
                      female_color:female_color,
                      lockRef:lockRef
                    });

                    view.setCard(Card);
                    store.setOnUpdate((props) => view.update(props || {}));
                    store.update.tree({ initial: true });

                    //setData(responseData);
                  }
                  else{
                      const current_url=window.location.href
                      const current_url_arr=current_url.split("?")
                      const params=current_url_arr.length>1?current_url_arr[1]:"";
                      if (params){
                        const params_arr=params.split("&");
                        let first_name=params_arr.length>0?params_arr[0].split("=")[1]:""
                        let last_name=params_arr.length>1?params_arr[1].split("=")[1]:""
                        let email=params_arr.length>2?params_arr[2].split("=")[1]:""
                        setFirstName(first_name)
                        setLastName(last_name)
                        setEmail(email)
                      }
                      setOpenStarter(true);
                  }});
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchDataAndUpdate();
  }, []);

  const AddRelative = (props) => {
      setOpen(true);
      setMemberId(props.d.data.id);
      setMemberName(props.d.data.data.first_name);
      setClickedMemberRelativeDetails(props.d.data.rels)

  };


  return (
    <>
      <Nav />
      <div id="toast-container" style={{ display: 'none' }}></div>

      <div className='familyName' ><u><i><EditText  value={memberFamilyName} onChange={handleFamilyNameChange} onSave={handleFinalFamilyNameChange}/></i></u></div>

      <div style={{ position: "relative"}}>
        <div id="FamilyChart" ref={familyChartRef} className="family-chart-container"></div>
        <TestDialog
        open={open}
        setOpen={setOpen}
        memberId={memberId}
        memberName={memberName}
        clickedMemberRelativeDetails={clickedMemberRelativeDetails}
        />
        <StarterDialog
        openStarter={openStarter}
        setOpenStarter={setOpenStarter}
        userId={userId}
        first_name={firstName}
        setFirstName={setFirstName}
        last_name={lastName}
        setLastName={setLastName}
        email={email}
        setEmail={setEmail}
        />
        <InviteAction
          isOpen={isModalOpen}
          onClose={closeModal}
          onInviteAction={handleInviteAction}
          onCancel={handleCancel}
          mobile={mobile}
          onInputChange={handleInputChange}
          familyChartElement={familyChartRef.current}
          memberFamilyName={memberFamilyName}
        />
      </div>
    </>
  );
}





function cardEditForm(props) {
  const currentURL = window.location.href.split("?")[0];
  const newURL = new URL(currentURL);

  if (!props || !props.d || !props.d.data) {
    let { gender } = props.datum.data;

    if (gender === "F") {
      gender = "M";
    } else if (gender === "M") {
      gender = "F";
    }
    const { spouses } = props.datum.rels;
    if (spouses && Array.isArray(spouses) && spouses.length > 0) {
      const spouse = spouses[0];
      newURL.searchParams.append("member_id", spouse);
      newURL.searchParams.append("event", "add");
      newURL.searchParams.append("gender", gender);
      newURL.searchParams.append("relation", "spouse");
      window.location.href = newURL.href;
    }

    return;
  }

  const { id } = props.d.data;

  newURL.searchParams.append("member_id", id);
  newURL.searchParams.append("event", "edit");
  window.location.href = newURL.href;
}

export default FamilyTree;
